import { ByteModeStringEncoding } from "../types";

const byteModeStringEncodings: ByteModeStringEncoding[] = ["default", "UTF-8", "SJIS"];

export default byteModeStringEncodings;
